import { makeImmutable } from "../../core";
import { getDepositIcon } from "../PDepositIcon";
export class DepositMaps {
    constructor(productDepositMap, categoryDepositMap, modifierItemDepositMap, customParameterChoiceDepositMap) {
        this.productDepositMap = productDepositMap;
        this.categoryDepositMap = categoryDepositMap;
        this.modifierItemDepositMap = modifierItemDepositMap;
        this.customParameterChoiceDepositMap = customParameterChoiceDepositMap;
        makeImmutable(this);
    }
    static create(catalogue) {
        const extraFees = Object.values(catalogue.extraFees);
        const productDepositMap = new Map();
        const categoryDepositMap = new Map();
        const modifierItemDepositMap = new Map();
        const customParameterChoiceDepositMap = new Map();
        for (const extraFee of extraFees) {
            if (extraFee.tag !== "PackagingFee" || extraFee.deposit === null) {
                continue;
            }
            const depositIcon = getDepositIcon(extraFee.deposit);
            for (const requirement of extraFee.requirements) {
                switch (requirement.tag) {
                    case "IndicatedProducts":
                        for (const productId of requirement.productIds) {
                            this.setIfConsistent(productDepositMap, productId, depositIcon);
                        }
                        break;
                    case "ProductsFromCategories":
                        for (const categoryId of requirement.categoryIds) {
                            this.setIfConsistent(categoryDepositMap, categoryId, depositIcon);
                        }
                        break;
                    case "IndicatedModifierItems":
                        for (const itemId of requirement.modifierItemIds) {
                            const key = DepositMaps.getModifierItemKey(requirement.modifierId, itemId);
                            this.setIfConsistent(modifierItemDepositMap, key, depositIcon);
                        }
                        break;
                    case "IndicatedCustomParameters":
                        for (const choiceId of requirement.customParameterChoiceIds) {
                            const key = DepositMaps.getCustomParameterChoiceKey(requirement.customParameterId, choiceId);
                            this.setIfConsistent(customParameterChoiceDepositMap, key, depositIcon);
                        }
                        break;
                }
            }
        }
        return new DepositMaps(productDepositMap, categoryDepositMap, modifierItemDepositMap, customParameterChoiceDepositMap);
    }
    getProductDeposit(productId) {
        var _a;
        return (_a = this.productDepositMap.get(productId)) !== null && _a !== void 0 ? _a : null;
    }
    getCategoryDeposit(categoryId) {
        var _a;
        return (_a = this.categoryDepositMap.get(categoryId)) !== null && _a !== void 0 ? _a : null;
    }
    getModifierItemDeposit(modifierId, itemId) {
        var _a;
        const key = DepositMaps.getModifierItemKey(modifierId, itemId);
        return (_a = this.modifierItemDepositMap.get(key)) !== null && _a !== void 0 ? _a : null;
    }
    getCustomParameterChoiceDeposit(customParameterId, choiceId) {
        var _a;
        const key = DepositMaps.getCustomParameterChoiceKey(customParameterId, choiceId);
        return (_a = this.customParameterChoiceDepositMap.get(key)) !== null && _a !== void 0 ? _a : null;
    }
    static getModifierItemKey(modifierId, itemId) {
        return `${modifierId}:${itemId}`;
    }
    static getCustomParameterChoiceKey(customParameterId, choiceId) {
        return `${customParameterId}:${choiceId}`;
    }
    /**
     * We don't show deposit icon if there are conflicting deposit definitions,
     * e.g. SingleUsePlasticBottle and MetalCan for the same item.
     */
    static setIfConsistent(map, key, value) {
        const existing = map.get(key);
        if (existing === undefined) {
            map.set(key, value);
        }
        else if (existing !== null && existing.deposit !== value.deposit) {
            map.set(key, null); // Mark as conflicting
        }
    }
}
